import { Link } from "react-router-dom";
import styled from "styled-components";
import TextareaAutosize from "react-textarea-autosize";

export const SearchBarDiv = styled.div`
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  margin-top: 2rem;
  position: relative;
`;

export const SearchBar = styled.form`
  width: 20rem;
  border: none;
`;

export const Input = styled.input`
  width: 100%;
  /* color: #6450d2; */
  padding-right: 3rem;
  padding-left: 1rem;
  height: 2.5rem;
  border: 1px solid hsl(0, 0%, 80%);
  outline: none;
  border-radius: 10px;
  background-color: white;

  &:focus {
    border-color: hsl(0, 0%, 80%);
  }
`;

export const FAQListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 2rem;
`;

export const ArticuloStyle = styled(Link)`
  display: grid;
  grid-template-columns: 90% 10%;
  width: 100%;
  height: 5rem;
  border: 1px solid #dce6e6;
  border-radius: 10px;
  padding: 10px 45px;

  &:hover {
    background-color: #f5faff;
  }

  @media (max-width: 768px) {
    grid-template-columns: 85% 15%;
    padding: 15px 30px;
  }
`;

export const LinkTitleDiv = styled.div`
  display: flex;
  align-items: center;
`;

export const LinkTitle = styled.p`
  color: #3c6ebe;
  font-weight: bold;
  font-size: 16.5px;

  @media (max-width: 768px) {
    font-size: 13.5px;
  }
`;

export const Ratings = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  align-items: center;
  justify-content: center;
`;

export const ReturnLink = styled(Link)`
  text-decoration: underline;
  padding: 0.5rem;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #3948ff;
    color: white;
    border-radius: 7px;
    text-decoration: none;
  }
`;

// This section is for the detailed article
export const ArticleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2rem;
  min-height: 70vh;
`;

export const Article = styled.div`
  display: flex;
  flex-direction: column;
  width: 60%;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 768px) {
    width: 85%;
  }
`;

export const ThumbImage = styled.img`
  width: 20px;
  height: 20px;

  @media (max-width: 768px) {
    width: 17px;
    height: 17px;
  }
`;

export const Encuesta = styled.div`
  @media (min-width: 768px) {
    position: fixed;
    top: 12rem;
    left: 7.5rem;
    display: flex;
    flex-direction: column;
    height: 10rem;
    width: 13rem;
    border-radius: 10px;
    padding: 1rem;
    font-size: 16px;
    gap: 5px;
  }

  @media (max-width: 768px) {
    width: 85%;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const EncuestaForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const EncuestaBtn = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  height: 2rem;
  border: 1px solid transparent;
  border-radius: 7px;
  cursor: pointer;
  font-size: 15px;
  font-weight: normal;
  background-color: ${(props) => props.checked && "#3948ff"};
  color: ${(props) =>
    props.checked ? "white" : props.colorGray ? "gray" : "darkslategray"};

  &:hover {
    background-color: #3948ff;
    color: white;
  }

  &:focus {
    outline: none;
  }
`;

export const Observaciones = styled(TextareaAutosize)`
  border: 1px solid #dce6e6;
  border-radius: 5px;
  font-size: 13px;
  min-height: 60px;
  text-justify: start;
  align-self: flex-start;
  width: 100%;
  padding: 3px;
  margin-top: 8px;

  &:focus {
    outline: none;
    border-color: #787878;
  }
`;

export const EncuestaSubmit = styled.button`
  /* flex items-center justify-center px-4 py-1 bg-green-300 rounded-md mt-2 */
  display: flex;
  align-items: center;
  border: 1px solid transparent;
  justify-content: center;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  background-color: #3dea83;
  border-radius: 7px;
  margin-top: 0.75rem;
  color: white;

  &:hover {
    background-color: white;
    color: #3dea83;
    border-color: #3dea83;
  }

  &:focus {
    outline: none;
  }
`;

export const NuevaSolicitudBtn = styled(Link)`
  width: 25%;
  padding: 20px 15px;
  text-decoration: underline;
  text-justify: center;
  text-align: center;
  color: #3948ff;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    text-decoration: none;
    box-shadow: 2px 2px 8px #b6d4ff;
    border-radius: 6px;
    background: #f5faff;
  }

  @media (max-width: 768px) {
    width: 75%;
  }
`;
